import { motion } from 'framer-motion';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Avatar, AvatarFallback, AvatarImage } from '../ui/avatar';
import { Lock, Send, Loader2 } from 'lucide-react';
import { getImageUrl } from '../../utils/imageUtils';

export const GroupChatTab = ({
  group, user, chatMessages,
  newMessage, setNewMessage,
  sendingMessage, onSendMessage, onJoin, chatEndRef,
}) => (
  <motion.div
    key="chat"
    initial={{ opacity: 0 }}
    animate={{ opacity: 1 }}
    exit={{ opacity: 0 }}
    className="max-w-2xl mx-auto"
  >
    {!group.is_member ? (
      <div className="text-center py-16 bg-card border border-border">
        <Lock className="h-16 w-16 text-muted-foreground mx-auto mb-4" />
        <h3 className="font-heading text-xl text-white mb-2">Members Only</h3>
        <p className="text-muted-foreground mb-4">Join the group to access chat</p>
        <Button onClick={onJoin} className="bg-primary text-black">Join Group</Button>
      </div>
    ) : (
      <div className="bg-card border border-border flex flex-col h-[60vh]">
        <div className="flex-1 overflow-y-auto p-4 space-y-3">
          {chatMessages.length === 0 ? (
            <div className="text-center py-8 text-muted-foreground">
              No messages yet. Start the conversation!
            </div>
          ) : (
            chatMessages.map((msg) => {
              const isMe = msg.user_id === user?.id;
              return (
                <div key={msg.id} className={`flex ${isMe ? 'justify-end' : 'justify-start'}`}>
                  <div className={`flex items-start gap-2 max-w-[80%] ${isMe ? 'flex-row-reverse' : ''}`}>
                    {!isMe && (
                      <Avatar className="h-8 w-8">
                        <AvatarImage src={getImageUrl(msg.user?.profile_picture)} />
                        <AvatarFallback className="bg-primary/20 text-primary text-xs">
                          {msg.user?.name?.charAt(0)}
                        </AvatarFallback>
                      </Avatar>
                    )}
                    <div>
                      {!isMe && <p className="text-xs text-muted-foreground mb-1">{msg.user?.name}</p>}
                      <div className={`p-3 ${
                        isMe
                          ? 'bg-primary text-black rounded-tl-lg rounded-tr-lg rounded-bl-lg'
                          : 'bg-black border border-border text-white rounded-tl-lg rounded-tr-lg rounded-br-lg'
                      }`}>
                        <p className="text-sm">{msg.content}</p>
                      </div>
                      <p className={`text-xs text-muted-foreground mt-1 ${isMe ? 'text-right' : ''}`}>
                        {new Date(msg.created_at).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
                      </p>
                    </div>
                  </div>
                </div>
              );
            })
          )}
          <div ref={chatEndRef} />
        </div>

        <form onSubmit={onSendMessage} className="border-t border-border p-4 flex gap-2">
          <Input
            placeholder="Type a message..."
            value={newMessage}
            onChange={(e) => setNewMessage(e.target.value)}
            className="flex-1 bg-black border-border"
            data-testid="group-chat-input"
          />
          <Button type="submit" disabled={sendingMessage || !newMessage.trim()} className="bg-primary text-black" data-testid="group-chat-send-btn">
            {sendingMessage ? <Loader2 className="h-4 w-4 animate-spin" /> : <Send className="h-4 w-4" />}
          </Button>
        </form>
      </div>
    )}
  </motion.div>
);
